// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import App from './App'
import router from './router'

// 导入全局样式
import './assets/base.css'

//axios
import axios from 'axios'
import moment from 'moment'
// iconfont
import './assets/icon/iconfont.css'

// axios.defaults.baseURL = 'http://39.99.231.153:8080/api/'
// 跨域，index.js中proxyTable配
// axios.defaults.baseURL = 'http://localhost:8000/api'

axios.defaults.baseURL = '/api'
Vue.prototype.axios = axios

Vue.config.productionTip = false



// axios拦截器,主要拦截403错误
axios.interceptors.response.use(
  response => {
    // console.log('拦截器响应成功')
    return response
  },
  error => {
    console.log('拦截器响应失败')
    console.log(error)
    if (error.request) {
      console.log(error.request)
    } else if (error.response) {
      console.log(error.response.data);
      console.log(error.response.status);
    }
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误(400)';
          break;
        case 401:
          error.message = '未授权，请重新登录(401)';
          break;

        case 403:
          // 跳转到login 
          let url = window.location.href
          // console.log(url.lastIndexOf('/'))
          // console.log(url.slice(0,url.lastIndexOf('/')))
          url = url.slice(0, url.lastIndexOf('/'))
          alert(error.response.data.detail)
          window.location.href = url + '/login'
        default:
          error.message = `连接出错(${error.response.status})!`;
      }
    } else {
      error.message = '连接服务器失败!'
    }
    return Promise.reject(error)
  }
)


// 过滤器
Vue.filter('fmtdate', (v) => {
  return moment(v).format('YYYY-MM-DD')
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js